import { useSelector } from 'react-redux';

function selectDemoEventId(state) {
    return state.ui.demoEventId;
}

export function useDemoEventId() {
    return useSelector(selectDemoEventId);
}
